import { NgModule } from '@angular/core';
import { CommonProjectService } from './project.service';
import { CommonAddressService } from './address.service';
import { CommonContactPersonService } from './contact-person.service';
import { CommonBranchService } from './branch.service';
import { CommonUserService } from './user.service';
import { AvailabilityService } from './availability.service';
import { OpcoPolicyLinksService } from './opco-policy-links.service';
import { ProductTranslationsService } from './product-translations.service';
import { RightsService } from './rights.service';
import { CommonRoleService } from './role.service';

@NgModule({
    imports: [],
    declarations: [],
    exports: [],
    providers: [
        CommonProjectService,
        CommonAddressService,
        CommonContactPersonService,
        CommonBranchService,
        CommonUserService,
        AvailabilityService,
        OpcoPolicyLinksService,
        ProductTranslationsService,
        RightsService,
        CommonRoleService
    ]
})
export class CommonServiceModule {}
